var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReleased(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 104,
    viewBox: "0 0 114 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_6583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.800781 25.7227V74.9385C0.800781 75.9482 1.34063 76.8879 2.22037 77.3878L43.4185 101.181C44.2982 101.691 45.3779 101.691 46.2477 101.181L87.4458 77.3878C88.3255 76.8779 88.8654 75.9482 88.8654 74.9385V25.7227L44.8281 51.1453L0.800781 25.7227Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.800781 25.7227L44.8381 0.300049L88.8754 25.7227L44.8381 51.1554L0.800781 25.7227Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8059 35.5497L61.8332 10.1271L71.7503 15.8554L27.713 41.2881L27.693 60.3226L17.7959 54.6142L17.8059 35.5497Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8379 51.1553V101.321",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4796 82.6462V91.0538L23.334 82.1463V73.7388L38.4796 82.6462Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7556 104C102.421 104 113.498 92.9223 113.498 79.2571C113.498 65.592 102.421 54.5143 88.7556 54.5143C75.0905 54.5143 64.0127 65.592 64.0127 79.2571C64.0127 92.9223 75.0905 104 88.7556 104Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7549 88.4645V70.0498",
    stroke: "white",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5479 79.2571L88.7552 70.0498L97.9725 79.2571",
    stroke: "white",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_6583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.997,
    height: 104,
    fill: "white",
    transform: "translate(0.500977)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleased);
export default __webpack_public_path__ + "static/media/released.6fa6cd8d4dd7c142a20409e200460d3c.svg";
export { ForwardRef as ReactComponent };